import React from 'react';
import { ArrowRight, ArrowLeftRight } from 'lucide-react';
import { jst, records, statusLabels, text } from './waf-model';
import type { WafComponent } from './waf-model';
import { actionName, describeStatement, object } from './waf-settings-model';

export function protectionSummary(settings: WafComponent) {
  const associations = records(settings.associations || settings.resources);
  const sites = [...new Set(associations.flatMap(resource => Array.isArray(resource.domains) && resource.domains.length ? resource.domains.map(String) : typeof resource.domainName === 'string' ? [resource.domainName] : []))];
  const rules = records(settings.rules);
  const rateCount = rules.filter(rule => describeStatement(rule.Statement || rule.statement).rates.length > 0).length;
  const complete = settings.status === 'active' && !settings.truncated && Array.isArray(settings.rules);
  const logging = object(settings.logging);
  return {
    associations, sites,
    defaultAction: ({ ALLOW: 'ルールに該当しなければ許可', BLOCK: 'ルールに該当しなければ遮断' } as Record<string, string>)[actionName(settings.defaultAction)] || '未取得',
    rate: rateCount ? `${rateCount} ルール設定あり` : complete ? '未設定（取得済みルール内）' : '未確認',
    logging: logging.status === 'active' ? '設定済み' : ['NOT_CONFIGURED', 'not_configured'].includes(String(logging.status)) ? '未設定' : statusLabels[String(logging.status)] || '未取得',
  };
}

export function WafContext({ settings }: { settings?: WafComponent }) {
  const sites = settings ? protectionSummary(settings).sites : [];
  return <div className="waf-context"><span>サイト：<strong>{sites.length ? sites.join('、') : '未確認'}</strong></span><span>環境：未確認</span><span className="waf-context-date">設定取得：{jst(settings?.checkedAt)} JST</span></div>;
}

export function ProtectionView({ settings, aclName }: { settings: WafComponent; aclName: string }) {
  const view = protectionSummary(settings);
  return <>
    <section className="waf-protection"><h3>対象サイトとWeb ACLの対応</h3>
      {view.associations.length ? view.associations.map((resource, index) => {
        const domains = Array.isArray(resource.domains) && resource.domains.length ? resource.domains.join('、') : text(resource.domainName || resource.domain || resource.site || 'サイト未確認');
        const arn = String(resource.resourceArn || resource.arn || '');
        const kind = resource.type === 'CloudFront' || arn.includes(':cloudfront:') ? 'CloudFront' : resource.type === 'ALB' || arn.includes(':loadbalancer/app/') ? 'ALB' : text(resource.type || 'リソース種類未確認');
        const confirmed = resource.associationStatus === 'CONFIRMED';
        return <div className="waf-association" key={index}><div className="waf-path"><span className="waf-path-node">{domains}</span><ArrowRight size={18} aria-label="経由" /><span className="waf-path-node">{kind}</span><ArrowLeftRight size={18} aria-label="関連付け" /><span className="waf-path-node">{aclName}</span><span className={`waf-association-status ${confirmed ? 'confirmed' : ''}`}>{confirmed ? '関連付け確認済み' : '関連付け未確認'}</span></div><p className="service-note">サイトとの対応：{resource.siteStatus === 'CONFIRMED' ? '確認済み' : '未確認'} / オリジンへの直接アクセス経路：未確認</p></div>;
      }) : <p>サイト・リソースとの対応は未確認です。</p>}
    </section>
    <dl className="waf-settings-summary"><div><dt>既定の動作</dt><dd>{view.defaultAction}</dd></div><div><dt>レート制限</dt><dd>{view.rate}</dd></div><div><dt>WAFログ設定</dt><dd>{view.logging}</dd></div></dl>
  </>;
}
